<template>
  <div class="section-content">   
      <h2>How is the colleague recognised via the Dialogue?</h2>

      <p>The Advance HE practice grid will be completed and submitted in advance, as for all PSF claims. This will provide reviewers with a context of the work and general coverage of the Dimensions of Practice. There will not be room for deeper analysis here, as this is invited during the dialogue.</p>

      <p>On the day of the dialogue, the colleague meets with two experienced reviewers for a 40-minute recorded dialogue. This is usually via Microsoft Teams, but can be face-to-face should the claimant wish.</p>

      <blockquote class="quoteBeforeAfter">
          <p>"…discuss how [they] influence the practice of peers in curriculum design, delivery and innovation through mentoring, management and co-ordination."</p>
      </blockquote>
  </div>

  <div class="section-content-image">
      <div :class="visibleClassFive" class="half-image-comp">
        <figure>
          <img src="../../assets/gif.gif" alt="">
          <figcaption>Dimensions of the framework</figcaption>
        </figure>
      </div>
      <div class="half-text-comp">
      <p>They should start off by providing a very succinct introduction to their role (since reviewers will have the grid before them) and begin to answer this question with concrete examples drawn from their recent work.  It can be a useful starting point to employ the vocabulary of the prompt question. They may describe a ‘case study’ (that is, an aspect of the job) which exemplifies a range of dimensions, or discuss aspects thematically, as suggested by the Dimensions of Practice for SF, with illustrations drawn from their work over the last few years.  They should explain, as they go, why and how leadership decisions were taken, any challenges, and means of evaluation for effectiveness, adding information on impacts, either immediate or longer term. An evidence-based account with some sense of both difficulties and achievements, including decision-making processes, will assist the reviewers to ‘tick off’ relevant SF aspects.</p>
      <p v-intersection.once="onIntersection">Importantly, the onus is on the reviewers to ensure all dimensions are explored, so they will interject regularly, to satisfy themselves that every area is fully met. For instance, if the claimant explains an activity clearly but fails to explain how they knew it was effective, this might prompt a question on evaluation methods. Or having discussed enhancing colleagues’ classroom techniques, they could be asked about inclusivity strategies. It is not therefore necessary for the claimant to try and cover everything at once; instead they should try and create natural opportunities for reviewer interjections, including asking ‘Would you like to know more about any aspect of this?’ Claimants should aim to participate in a dialogue rather than give a monologue.</p>
      <p>At the end of forty minutes, the claimant will leave the meeting, returning in ten minutes for a brief follow-up from the reviewers, which might include dealing with an aspect not discussed fully during the dialogue. (Reviewers may agree there is nothing more to ask, as they are fully satisfied on all counts, in which case they will merely thank the claimant and explain next steps.)</p>
      </div>
  </div>  

     <div  class="section-content">   

      <h3 style="margin-top: 3rem;">Reflective activity</h3>

      <p>Think about the leadership experience of the claimant, and assess its substance in the context of a free-flowing dialogue about sustained  leadership in HE learning and teaching.</p>

        <p>Consider the relevant vocabulary in the light of their claim, including the verbs: <i>influence</i>, <i>mentor</i>, <i>manage</i>, <i>co-ordinate</i> and the nouns: <i>curriculum design</i>, <i>delivery</i>, <i>innovation</i>, <i>evaluation</i>, <i>impact</i>. If you are unconvinced that an authentic conversation could comfortably take place, consider redirecting the claimant to e.g. the written route.</p>


    
  </div>

    <!-- <div class="section-content wysiwyg-hide">   
    <div class="section-question  background-colour">
      <div class="question">   
        <p><b>Jot down some questions to ask in your initial meeting which will help clarify these aspects for the claimant.</b></p>
      </div>  
      <WYSIWYGThree :isEditingThree="isEditingThree" @submitQuestionThree = "saveTextThree" />
    </div>
    </div> -->

</template>

<script>
import { scroll } from 'quasar'
import { ref } from '@vue/reactivity'
import { computed } from '@vue/runtime-core'
import { useQuasar } from 'quasar'
import WYSIWYGThree from '../WYSIWYGThree.vue'
export default {
  components: { WYSIWYGThree },
  setup() {
        const { getScrollTarget } = scroll
        const visible = ref(true)
        const imageVisible = ref(true)

        const onIntersection = (entry) => {
            const mediaQuery = window.matchMedia('(min-width: 1200px)')
            mediaQuery.matches ? visible.value = entry.isIntersecting : visible.value = true 
        }

        const visibleClassFive = computed(() => { 
            if(visible.value) {
                return 'show-five'
            } else {
                return 'hide-five'
            }
        })

        const isEditingThree = ref(true) 

        const sessionMemory = useQuasar()

        const saveTextThree = (save) => {
          sessionMemory.localStorage.set('questionThree', save)
          isEditingThree.value = !isEditingThree.value
          console.log(sessionMemory.localStorage.has('questionThree'))  
        }

        return {
          isEditingThree,
          saveTextThree,
          getScrollTarget,
          onIntersection,
          visible,
          visibleClassFive,
          imageVisible
        }

  }
}

</script>

<style scoped>

</style>

